var _defs, _style, _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSetUpCooling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 264.72815 446.4055",
    xmlSpace: "preserve",
    width: 264.72815,
    height: 446.40552,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1617"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style1442"
  }, "\n\t.st0{fill:none;}\n\t\n\t\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;stroke:#000000;stroke-width:4.103;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t\n\t\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;stroke:#000000;stroke-width:4.1031;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;}\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:1.765;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#FFFFFF;stroke-width:0.4233;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;stroke:#000000;stroke-width:1.28;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;}\n\t\n\t\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;stroke:#000000;stroke-width:0.4233;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st9{fill:none;stroke:#FFFFFF;stroke-width:0.8804;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st10{fill-rule:evenodd;clip-rule:evenodd;stroke:#FFFFFF;stroke-width:0.8804;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#FFFFFF;stroke-width:2.65;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.824971,-0.552394,0.959237,0.824971,-2486.3765,457.7861)",
    id: "g1462"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.494445,0,0,0.375215,912.102,-927.427)",
    id: "g1448"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 2268.1,5086.4 -82.9,39 -14.2,106.2 82.4,20.5 74.5,-56.1 18.2,-96.1 z",
    id: "path1446"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.494445,0,0,0.375215,912.102,-927.427)",
    id: "g1452"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 2314.4,5129.1 c 0,0 -54,31.3 -65.1,105.5 -49.3,-6.1 -63.7,-14.1 -63.7,-14.1 l 11.7,-82.7 43.5,21.6 c 0,0 50.9,-16.3 73.6,-30.3 z",
    id: "path1450"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.54725,0,0,1.17415,-412.176,740.131)",
    id: "g1456"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 1593.2,241.4 c 0,0 1.9,-1.3 2.2,-3.9 0.3,-2.6 5.9,-23.8 5.9,-23.8 0,0 0.3,0.1 0.8,-0.1 0.5,-0.2 -5.2,26.3 -5.2,26.3 z",
    id: "path1454"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.09615,0,0,0.831825,136.844,1290.98)",
    id: "g1460"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 1745.9,-365.3 c 0,0 -18.2,-6.4 -30.9,3.3 18.8,-2.8 19.3,-4.9 30.9,-3.3 z",
    id: "path1458"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.857266,0.481134,-0.881329,0.904297,1700.9035,-731.5879)",
    id: "g1482"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.494445,0,0,0.375215,932.124,-830.339)",
    id: "g1472"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35052,0,0,0.915179,-243.95,1150.29)",
    id: "g1468"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.9764,-0.2158,0.2158,-0.9764,-4534.957,10258.919)",
    className: "st3",
    cx: -1707.5,
    cy: 5377,
    rx: 55.099998,
    ry: 16.9,
    id: "ellipse1464"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.9764,-0.2158,0.2158,-0.9764,-4534.957,10258.919)",
    className: "st2",
    cx: -1707.5,
    cy: 5377,
    rx: 55.099998,
    ry: 16.9,
    id: "ellipse1466"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m -2782.3,5749.7 -73.5,18.7 14.4,108.6 89.1,44.2 60.3,-39 -7.6,-96.8 z",
    id: "path1470"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.54725,0,0,1.17415,-230.618,789.634)",
    id: "g1476"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m -116.7,479.6 0.8,12.8 c 0,0 -5.1,8.2 -9.5,10 -4.4,1.8 12.8,-6.7 12.8,-6.7 z",
    id: "path1474"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.494445,0,0,0.375215,932.124,-830.339)",
    id: "g1480"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m -2715.7,5797.9 c 0,0 -64.6,25.6 -55.7,101.1 -6.7,-2 -29.9,-15.4 -62.6,-28.5 2.7,-27.3 0.6,-57.1 -6.1,-85.6 12.5,47.5 49.5,55 84.2,31.2 0,0 21,-9.5 40.2,-18.2 z",
    id: "path1478"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.08252,-0.149091,0.258898,1.08252,-1064.1395,-250.2301)",
    id: "g1492"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.494445,0,0,0.375215,774.885,-840.885)",
    id: "g1486"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 355.1,4050.8 -71.6,35 -5,117.8 75.3,31.8 62.7,-55.1 9.4,-106.1 z",
    id: "path1484"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.494445,0,0,0.375215,774.885,-840.885)",
    id: "g1490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 399.7,4103.8 c 0,0 -89.4,33.2 -55.1,114.6 -44.7,-12.2 -53.8,-25.6 -53.8,-25.6 l 4.5,-91.6 32.1,24.4 c 0,0 39.4,-5.4 72.3,-21.8 z",
    id: "path1488"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g1522",
    transform: "translate(-462.68655,-186.7809)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.956709,0,0,0.673311,-115.865,826.292)",
    id: "g1498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1496"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 833.8,-666.5 c 4.3,3.4 8.4,7.7 11.9,12.8 10.2,14.5 15.9,34.2 15.9,54.7 v 222.8 c 0,28.1 -12.2,52.1 -29.5,61.8 1.1,1.5 1.7,3.1 1.7,4.7 0,12.6 -35.6,22.9 -79.4,22.9 -43.8,0 -79.4,-10.3 -79.4,-22.9 0,-1.6 0.6,-3.2 1.7,-4.7 -17.3,-9.8 -29.5,-33.8 -29.5,-61.8 V -599 c 0,-20.5 5.7,-40.2 15.9,-54.7 3.6,-5.1 7.6,-9.4 11.9,-12.8 v -43.9 h 158.7 v 43.9 z m -20.7,340.7 c -11.2,3.2 -36.2,9.6 -58.6,9.6 -22.4,0 -47.5,-6.4 -58.6,-9.6 -2.1,-7.2 -6.2,-13 -11.4,-15.9 -9.7,-5.4 -16.5,-18.9 -16.5,-34.5 0,-62.7 0,-156.7 0,-222.8 0,-12.7 3.6,-24.9 9.9,-33.9 2.2,-3.1 4.7,-5.8 7.3,-7.9 6.6,-5.2 10.6,-15 10.6,-25.7 v -14.6 c 0,0 78.9,0 117.4,0 v 14.6 c 0,10.7 4.1,20.5 10.6,25.7 2.7,2.1 5.1,4.8 7.3,7.9 6.3,9 9.9,21.2 9.9,33.9 v 222.8 c 0,15.7 -6.8,29.1 -16.5,34.5 -5.2,2.9 -9.3,8.7 -11.4,15.9 z",
    id: "path1494"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1504"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 563.6,-874.6 -4.4,5.5 -107,6.6 0.4,13.9 c 0,0 0.7,0.9 -0.8,5 -7.4,5.4 -24.8,27.2 -24.8,59.1 0,31.9 -5.8,49.7 -8,50.8 0,-22.3 0,-60.4 0,-60.4 0,0 -3.4,-25 24.2,-49.9 0.6,-26.6 -1.9,-29 -1.9,-29 z",
    id: "path1500"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 563.6,-874.6 -4.4,5.5 -107,6.6 0.4,13.9 c 0,0 0.7,0.9 -0.8,5 -7.4,5.4 -24.8,27.2 -24.8,59.1 0,31.9 -5.8,49.7 -8,50.8 0,-22.3 0,-60.4 0,-60.4 0,0 -3.4,-25 24.2,-49.9 0.6,-26.6 -1.9,-29 -1.9,-29 z m -1.5,0.8 -3.2,3.9 -106.8,6.6 c -0.3,0 -0.6,0.4 -0.6,0.8 l 0.4,13.9 0.6,0.7 -0.5,-0.3 c 0,0 0.1,0.4 0,0.9 -0.1,0.7 -0.3,1.7 -0.8,3.1 -7.6,5.6 -25,27.6 -25,59.7 0,22.2 -2.8,37.5 -5.3,45.1 -0.5,1.7 -1.1,3 -1.5,3.9 v -58.6 c 0,0 0,-0.1 0,-0.1 0,0 -3.2,-24.6 24,-49.1 0.2,-0.1 0.2,-0.4 0.3,-0.6 0.4,-16.1 -0.4,-23.4 -1.1,-26.7 -0.1,-0.7 -0.3,-1.2 -0.4,-1.6 z",
    id: "path1502"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1508"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m 563.6,-870.7 v 28 c 0,0 20.3,18.4 21.4,47.2 1.1,28.8 0.1,168.9 0.1,168.9 0,0 2,19.9 -23,37.8 -0.1,2.3 -0.2,3.4 -0.2,3.4",
    id: "path1506"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m 573.7,-797.3 v 170.4",
    id: "path1510"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1516"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m 421.4,-626.9 c 0,0 -1.6,23.7 19,37.2 4.4,-2.8 4.9,1.4 4.9,1.4 l -0.6,4.6 c 0,0 61.9,30.4 117.3,-1.7",
    id: "path1514"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1520"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m 431,-749.5 0.8,122.6 c 0,0 0,17.2 11.1,22.7",
    id: "path1518"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.957109,0.219863,-0.381794,0.957109,128.65845,-285.1129)",
    id: "g1612"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.985159,-0.403007,0.753856,1.06122,-1339.1,483.521)",
    id: "g1542"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-50.1899,-753.399)",
    id: "g1528"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 1181.5,1148.9 c 1,3.6 -16.9,47.5 -16.9,47.5 0,0 -12.4,10.1 -44,15.1 -45.4,27 -41.5,27.4 -41.5,27.4 0,0 -16.5,6.3 -14.1,-11 19.1,-32.8 34.4,-27 34.4,-27 0,0 14.2,-14.7 -38.6,-36 -38.9,-0.3 -69.6,29 -69.6,29 0,0 -15.7,4.5 -18,1 -10.7,-7.4 58.9,-49.8 58.9,-49.8 0,0 22.9,-16.2 49.7,-14.8 30,4.3 47.2,6.8 66.7,9.7 11.2,3 32,5.4 33,8.9 z",
    id: "path1524"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 1078.9,1239 c -1.8,0.6 -16.1,5.1 -13.9,-11.1 19.1,-32.8 34.4,-27 34.4,-27 0,0 14.2,-14.7 -38.6,-36 -38.9,-0.3 -69.6,29 -69.6,29 0,0 -15.7,4.5 -18,1 -10.7,-7.4 58.9,-49.8 58.9,-49.8 0,0 22.9,-16.2 49.7,-14.8 30,4.3 47.2,6.8 66.7,9.7 11.1,3 32,5.3 33,8.9 1,3.6 -16.9,47.5 -16.9,47.5 0,0 -12.4,10.1 -44,15.1 -31.5,18.8 -39.3,24.7 -41.1,26.5 -0.1,-0.1 -0.2,-0.1 -0.2,-0.1 0,0 0,0 0,0 -0.1,0 -0.2,0 -0.3,0.1 z m -0.5,-0.8 c -1.1,0.4 -3.9,1.1 -6.6,0.8 -2.2,-0.2 -4.4,-1.2 -5.5,-3.8 -0.7,-1.6 -0.9,-3.9 -0.5,-7 18.6,-31.7 33.3,-26.3 33.3,-26.3 l 0.4,0.2 0.4,-0.4 c 0,0 1.5,-1.5 2,-4.4 0.3,-1.8 0.1,-4.1 -1.2,-6.9 -3.1,-6.4 -12.8,-15.6 -39.5,-26.3 h -0.1 -0.1 c -37.6,-0.3 -67.5,26.8 -70,29.1 -1.2,0.3 -7.9,2.1 -12.7,2.2 -1.3,0 -2.5,-0.1 -3.3,-0.3 -0.4,-0.2 -0.8,-0.3 -1,-0.6 l -0.1,-0.1 -0.1,-0.1 c -0.4,-0.3 -0.7,-0.7 -0.8,-1.1 -0.1,-0.5 0.1,-1.1 0.4,-1.7 0.5,-1.1 1.3,-2.3 2.5,-3.7 12.3,-14.6 56.7,-41.5 56.7,-41.5 h 0.1 c 0,0 22.7,-16 49.2,-14.7 30,4.3 47.1,6.8 66.6,9.6 7.8,2.1 20.3,3.9 27.5,6 1.8,0.5 3.2,1.1 4.1,1.6 0.4,0.3 0.7,0.5 0.8,0.8 v 0 c 0.1,0.2 0,0.6 -0.1,1.1 -0.2,1.1 -0.6,2.7 -1.2,4.6 -3.8,12.3 -14.2,37.9 -15.4,40.8 -1.7,1.3 -14.4,10.1 -43.4,14.8 h -0.1 l -0.1,0.1 c -25.5,15.2 -35.5,22 -39.3,25 -2.1,1.1 -2.7,1.8 -2.9,2.2 z",
    id: "path1526"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-50.1899,-753.399)",
    id: "g1534"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 1042.7,1167.5 -34.1,47.4 c 0,0 7.8,4.5 15,-3.5 7.2,-8 25.4,-31.2 25.4,-31.2 0,0 3.8,-0.1 5.6,0.5 -4.2,5 -22.9,30.8 -22.9,30.8 0,0 7.7,3.8 13.9,-3.3 6.3,-7 20.7,-19.1 20.7,-19.1 0,0 29.5,1.2 32.1,5 1.6,-10.8 -33.9,-31.6 -55.7,-26.6 z",
    id: "path1530"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 1042.7,1167.5 -34.1,47.4 c 0,0 7.8,4.5 15,-3.5 7.2,-8 25.4,-31.2 25.4,-31.2 0,0 3.8,-0.1 5.6,0.5 -4.2,5 -22.9,30.8 -22.9,30.8 0,0 7.7,3.8 13.9,-3.3 6.3,-7 20.7,-19.1 20.7,-19.1 0,0 29.5,1.2 32.1,5 1.6,-10.8 -33.9,-31.6 -55.7,-26.6 z m 0.4,0.9 c 15.1,-3.3 36.6,5.7 47.7,15.1 2.8,2.4 4.9,4.8 6.1,7 0.3,0.6 0.6,1.2 0.7,1.8 0,0 0,0 0,0 -1.5,-0.7 -4,-1.4 -6.9,-1.9 -9.6,-1.7 -24.1,-2.3 -24.1,-2.3 h -0.3 l -0.2,0.2 c 0,0 -14.5,12.1 -20.8,19.2 -4.5,5.1 -9.9,4.1 -12,3.4 3.6,-5 18.3,-25.2 22.1,-29.6 l -0.2,-1.6 c -1.8,-0.6 -5.8,-0.6 -5.8,-0.6 h -0.4 l -0.3,0.3 c 0,0 -18.2,23.1 -25.4,31.2 -5.3,5.9 -11,4.6 -13.1,3.7 -0.2,0.1 32.9,-45.9 32.9,-45.9 z",
    id: "path1532"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-50.1899,-753.399)",
    id: "g1540"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 1035.8,1170.7 c -5.3,3 -49,31.1 -49.8,37.4 4.8,5.4 13.1,4.2 18.1,1.1 9.1,-5.8 37,-41.4 31.7,-38.5 z",
    id: "path1536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 1035.8,1170.7 c -5.3,3 -49,31.1 -49.8,37.4 4.8,5.4 13.1,4.2 18.1,1.1 9.1,-5.8 37,-41.4 31.7,-38.5 z m -0.9,1.6 c 0,0.1 -0.1,0.2 -0.1,0.3 -4.7,7.7 -23.8,31.2 -30.9,35.9 -4.7,2.8 -12.3,4.1 -16.9,-0.6 0.1,-0.3 0.3,-0.6 0.6,-0.9 0.8,-1.1 2.2,-2.4 3.9,-4 10.8,-10 36.6,-26.7 43.4,-30.7 z",
    id: "path1538"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1546"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m 108.4,-884.7 c 0,0 -0.9,-2.8 -1.8,-2.9",
    id: "path1544"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.552631,0.115658,-0.32063,0.882243,682.48,1094.73)",
    id: "g1550"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "m -1545.5,-601.1 c 0,0 8.6,-3.5 8.6,-9.1 -0.1,-5.6 -1.1,-3.8 -1.1,-3.8 0,0 -5.1,-4 -6.2,-2.6",
    id: "path1548"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.18726,0.160676,-0.211734,0.900964,165.726,1005.05)",
    id: "g1554"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "m -110.9,-668.4 4.3,-14.5 c 0,0 -9.3,-5.8 -13.3,2 -3.9,7.8 -1.6,9.3 -3,11.2 -1.2,1.8 4.4,7.6 12,1.3 z",
    id: "path1552"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1558"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m 141.3,-884.7 c 0,0 2.8,-4.2 9.8,-2",
    id: "path1556"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1562"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m 49.3,-866.9 c 0,0 -2,-6.6 -4.2,-8.8",
    id: "path1560"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1566"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m 44.8,-879 c 0,0 7.2,9.3 6,8",
    id: "path1564"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1570"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m 79.5,-913.5 c 0,0 6,2.2 7.7,4.8",
    id: "path1568"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1574"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m 85.8,-916.4 c 0,0 3.1,5.3 3.2,8.9",
    id: "path1572"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1578"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m 141,-903.1 c 0,0 19.5,-15.6 38.6,-16.2 -23.8,7.9 -34.3,15.7 -33.7,23.5",
    id: "path1576"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1582"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m 77,-850.2 c 0,0 4.3,-0.1 4.7,-2.3",
    id: "path1580"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.12368,0.332313,-0.437911,0.852714,388.969,860.872)",
    id: "g1586"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "m -361.7,-433.8 c 0,0 -2.2,3 -1.3,4.3 0.9,1.3 -3.3,-3.1 1.3,-4.3 z",
    id: "path1584"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.02954,0,0,0.650697,151.679,1315.53)",
    id: "g1590"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "m -52.4,-1508 c 0,0 6.1,7.4 6.4,9.2 0.3,1.9 -2,-3.6 -7.1,-4.8",
    id: "path1588"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1594"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m 108.5,-884 c 0,0 -5.2,-1.8 -5.4,-1.1",
    id: "path1592"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1598"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m 59.7,-848.3 c 0,0 2.7,2.9 3.3,3.2",
    id: "path1596"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1602"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m 59.4,-846.8 c 0,0 2.6,4.1 3.2,3.5",
    id: "path1600"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1606"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m 77.2,-847.2 c 0,0 3.4,0.1 4,-1.9",
    id: "path1604"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1610"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m 80.4,-943.4 10,5.7 8.4,-10.1",
    id: "path1608"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetUpCooling);
export default __webpack_public_path__ + "static/media/set-up-cooling.676b9724d275c7e80b239f7f3871def4.svg";
export { ForwardRef as ReactComponent };